module.exports = __webpack_public_path__ + "static/media/portfolio.0f0208a1.png";